"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = require("./style");
var _fonts = require("../style/fonts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Link = _ref => {
  let {
    children,
    href,
    newTab,
    download,
    className,
    title,
    fontWeight
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_style.LinkStyled, {
    href: href,
    target: newTab ? '_blank' : '_self',
    rel: newTab ? 'noopener noreferrer' : undefined,
    download: download,
    className: className,
    title: title,
    fontWeight: fontWeight
  }, children);
};
Link.propTypes = {
  children: _propTypes.default.node.isRequired,
  href: _propTypes.default.string.isRequired,
  newTab: _propTypes.default.bool,
  download: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  className: _propTypes.default.string,
  title: _propTypes.default.string,
  fontWeight: _propTypes.default.oneOf([400, 500, 700])
};
Link.defaultProps = {
  newTab: false,
  download: false,
  className: undefined,
  title: '',
  fontWeight: _fonts.fontWeightMedium
};
var _default = exports.default = Link;